const footerLinks = [
  { href: "#prototype", label: "故事原型" },
  { href: "#history", label: "历史形象" },
  { href: "#evolution", label: "影视演变" },
  { href: "#works", label: "作品一览" },
  { href: "#character", label: "角色分析" },
  { href: "#difference", label: "与原著区别" },
  { href: "#legend", label: "野史解读" },
  { href: "#faq", label: "常见问答" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
                <i className="ri-movie-2-line"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                潘金莲电影
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-secondary-200">
              一个围绕潘金莲题材影视作品整理的内容专题，涵盖故事原型、历史真实形象、
              角色分析、野史解读，以及电影与原著区别和影视形象演变，方便你按兴趣展开查阅。
            </p>
          </div>

          <div className="md:col-span-4">
            <div className="font-label text-xs tracking-[0.2em] text-secondary-300 uppercase">
              页面分区
            </div>
            <ul className="mt-5 grid grid-cols-2 gap-3">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="font-label text-sm text-secondary-200 hover:text-accent-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="font-label text-xs tracking-[0.2em] text-secondary-300 uppercase">
              阅读提示
            </div>
            <p className="mt-5 text-sm leading-relaxed text-secondary-200">
              本站内容为资料整理与背景介绍，涉及影视作品信息以公开资料为准；
              野史与民间说法仅作了解，不作为已被证实的历史事实。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-label text-xs text-secondary-300">
            © 2026 潘金莲电影 · 内容专题
          </p>
          <a
            href="#home"
            className="inline-flex items-center gap-1 font-label text-xs text-secondary-200 hover:text-accent-300 transition-colors"
          >
            返回顶部
            <i className="ri-arrow-up-line"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}